/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/*
 * Create promise, resolve, and reject properties on "this" object, e.g. withResolvers.call(this).
 */
function withResolvers() {
  this.promise = new Promise(
    (resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    },
  );
  return this;
}

/**
 * @classdesc
 * Deferred that makes it easy to later reference the resolve and reject of a Promise instance.
 * @class
 */
class Deferred {
  /**
   * @constructor
   */
  constructor() {
    withResolvers.call(this);
  }

  /**
   * Support ES2023 Promise.withResolvers() as Deferred.withResolvers().
   */
  static withResolvers = function resolvers() { return withResolvers.call({}); };
}

/**
 * Polyfill the ES2023 Promise.withResolvers() if missing.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers
 */
export function polyfillPromise() {
  if (!Promise.withResolvers) {
    Promise.withResolvers = Deferred.withResolvers;
  }
}

export default Deferred;
